import type { ClientRequest, ProductDiscount } from '@commercetools/platform-sdk';

import type { ApiClientDetails, QueryArgs } from '../../types';
import { getQueryPredicate, QueryKey } from '../utils';

export function productDiscountApi({ apiRoot, ctpClient }: ApiClientDetails) {
    function productDiscountClientRequest(args?: QueryArgs): ClientRequest {
        return apiRoot().productDiscounts().get(args).clientRequest();
    }

    function fetchProductDiscounts(args?: QueryArgs): Promise<ProductDiscount[]> {
        const clientRequest = productDiscountClientRequest(args);

        return ctpClient().process(clientRequest, payload => Promise.resolve(payload.body.results), {
            accumulate: true,
        });
    }

    function fetchAllProductDiscounts(expand?: string | string[]): Promise<ProductDiscount[]> {
        return fetchProductDiscounts({ queryArgs: { expand } });
    }

    function getProductDiscountsByIds(ids: string[]): Promise<ProductDiscount[]> {
        return fetchProductDiscounts({
            queryArgs: { where: getQueryPredicate(ids, QueryKey.ID) },
        });
    }

    async function getProductDiscountById(id: string): Promise<ProductDiscount> {
        return (await apiRoot().productDiscounts().withId({ ID: id }).get().execute()).body;
    }

    return {
        fetchProductDiscounts,
        fetchAllProductDiscounts,
        getProductDiscountsByIds,
        getProductDiscountById,
    };
}
